import type { ImageFormats } from '@/types/chat';

const SIZES = ['thumbnail', 'small', 'medium', 'large'] as const;
const WIDTHS = { thumbnail: 156, small: 500, medium: 750, large: 1000 };

/**
 * The image at `size`, else the next larger size that exists, else the original.
 * Strapi only generates sizes smaller than the original, so a missing size means
 * the original is already about that small (or the formats weren't sent at all).
 */
export function sizedImage(url: string, formats: ImageFormats | undefined, size: keyof ImageFormats): string {
  for (const s of SIZES.slice(SIZES.indexOf(size))) {
    const u = formats?.[s];
    if (u) return u;
  }
  return url;
}

/** A srcset of every size that exists, plus the original when its width is known. */
export function imageSrcSet(url: string, formats: ImageFormats | undefined, width?: number): string | undefined {
  const entries = SIZES.filter((s) => formats?.[s]).map((s) => `${formats![s]} ${WIDTHS[s]}w`);
  if (width) entries.push(`${url} ${width}w`);
  return entries.length > 1 ? entries.join(', ') : undefined;
}
